export default __webpack_public_path__ + "static/media/CurriculumVitae.c2cb49d9.pdf";